module.exports = __webpack_public_path__ + "img/1722479580821-image.jpg.63ffd191.webp";